<span style="font-size: 1.2em; font-weight: bold;" class="d-block">{{ step3.getspan3 | translate }}</span>
<br />

<app-typeCPV-class [uid]="getUid()" [displayStar]="true" [parentForm]="parentForm" [objetComplementaire]="cpv.objetPrincipal" (preferenceSelected)="chargeDonneePreference($event)">
</app-typeCPV-class>

<span class="d-block">{{ step3.getspan4  | translate }}</span>

<button class="btn btn-outline-primary" (click)="addtypeCPVClass()">{{ step3.ajouter | translate}}</button>
  <div *ngFor="let obj of cpv.objetComplementaire| slice:0:4; let i = index">
      <button class="btn btn-outline-primary" (click)="removetypeCPVClass(i)">{{ step3.supprimer | translate }}</button>
      <app-typeCPV-class [uid]="getUid()+'_index_'+(i+1)" [displayStar]="false" [parentForm]="parentForm" [objetComplementaire]="obj">
      </app-typeCPV-class>
  </div>


